import React from 'react';
import PropTypes from 'prop-types';
import WithMore from '../WithMore';
import DistrictPreview from './DistrictPreview';
import { MainTitle } from './styles';

function DistrictsOverview({ items }) {
	return (
		<div>
			<MainTitle>
				Seznam obvodů
			</MainTitle>
			{items.map(item =><DistrictPreview districtNumber={item.id} name={item.name} candidates={item.candidates} key={item.name} />)}
		</div>
	)
}

export const CandidatesPropType = PropTypes.arrayOf(PropTypes.shape({
	name: PropTypes.string,
	partyName: PropTypes.string
}))

DistrictsOverview.propTypes = {
	items: PropTypes.arrayOf(PropTypes.shape({
		name: PropTypes.string,
		id: PropTypes.number,
		candidates: CandidatesPropType
	}))
}

export default WithMore(DistrictsOverview, { length: 7 })
